import { Link } from "wouter";
import { Restaurant } from "../../types";
import { formatCurrency, getRelativeDistance } from "../../lib/utils";

interface RestaurantCardProps {
  restaurant: Restaurant;
  showPrice?: boolean; // default true
}

const RestaurantCard = ({ restaurant, showPrice = true }: RestaurantCardProps) => {
  const {
    id,
    name,
    image,
    cuisine,
    description,
    rating,
    distance,
    location,
    price,
  } = restaurant;

  return (
      <div className="overflow-hidden rounded-xl bg-white shadow-md transition-all hover:shadow-lg dark:bg-gray-800">
        <div className="relative h-48">
          <img
              src={image}
              alt={name}
              className="h-full w-full object-cover"
          />
          <div className="absolute right-3 top-3 rounded-md bg-white px-2 py-1 text-sm font-medium text-primary dark:bg-gray-800 dark:text-primary-dark">
            {cuisine}
          </div>
        </div>
        <div className="p-6">
          <div className="mb-2 flex items-start justify-between">
            <h3 className="text-xl font-semibold text-gray-800 dark:text-white">
              {name}
            </h3>
            <div className="flex items-center">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4 text-yellow-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <span className="text-sm font-medium text-gray-800 dark:text-gray-200">
              {rating}
            </span>
            </div>
          </div>
          <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">
            {description}
          </p>
          <div className="mb-4 flex items-center text-sm text-gray-500 dark:text-gray-400">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mr-2 h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
              <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            <span>
            {getRelativeDistance(distance)} • {location}
          </span>
          </div>
          <div className="flex items-center justify-between">
            {showPrice ? (
                <span className="font-bold text-gray-800 dark:text-white">
              {formatCurrency(price)}
            </span>
            ) : <span />}

            {/* Uncomment this if you want a booking button */}
            {/* <Link href={`/booking/${id}`}> */}
            {/*   <a className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700"> */}
            {/*     Book Surprise */}
            {/*   </a> */}
            {/* </Link> */}
          </div>
        </div>
      </div>
  );
};

export default RestaurantCard;
